export const API_KEY = '9973533'; // PERSONAL API_KEY FROM PATREON
export const API_URL = `https://www.thecocktaildb.com/api/json/v2/${API_KEY}/latest.php`;